import { ButtonGroup, Grid, List, ListItem, ListItemText } from "@mui/material";
import React, { useEffect, useState } from "react";
import Typo from "../common/typo/Typo";
import ButtonView from "../common/button/ButtonView";
import { SelectView } from "../common/selectView/SelectView";
import { useDispatch, useSelector } from "react-redux";
import {
  FILTER_SECTION_STYLE,
  LIST_STYLE,
  MARGIN_B,
  MARGIN_TB,
  PADDING_SM,
  RIGHT_ALIGN,
  VIN_DECODE_FILTER_VIEW,
  VIN_DECODER_VIEW,
  LOADING,
  VIN_FILTER_TEXT,
  CENTER_ITEMS,
  HELPER_TEXT_STYLE,
} from "../../utils/GlobalConstants";
import { addItemInSelectedVehicle } from "../../store/SurveyPageData";
import { NO_DATA, LOADING_FAILED, VIN_ID_MSG } from "../../utils/GlobalMessageConstants";

const VinDialogView = (props) => {
  const dispatch = useDispatch();
  const [vin, setVin] = useState({});
  const [localVinData, setVinData] = useState({});
  const selectedVin = useSelector((state) => state?.SurveyPageData?.vinData);
  const [selectedSurvey,setSelectedSurvey] = useState(props.selectedSurvey);

  useEffect(() => {
    setVin(selectedVin);
  }, [selectedVin]);

  useEffect(() => {
    setSelectedSurvey(props.selectedSurvey);
  }, [props.selectedSurvey]);

  useEffect(() => {
    let loadVinData = {};
    if (
      vin.hasOwnProperty("vinItems") &&
      Object.keys(vin.vinItems).length > 0 &&
      vin.vinItems.hasOwnProperty("decodedVIN")
    ) {
      const decodeVIN = vin.vinItems.decodedVIN;
      loadVinData.vinData = {
        "Model Year":
          Object.keys(decodeVIN.CatalogVehicleDescription).length > 0
            ? decodeVIN.CatalogVehicleDescription.NAPAYearID
              ? decodeVIN.CatalogVehicleDescription.NAPAYearID
              : "--"
            : "--",
        Make:
          Object.keys(decodeVIN).length > 0
            ? decodeVIN.Make
              ? decodeVIN.Make
              : "--"
            : "--",
        Model:
          Object.keys(decodeVIN).length > 0
            ? decodeVIN.Model
              ? decodeVIN.Model
              : "--"
            : "--",
        "Production Seq. Number":
          Object.keys(decodeVIN).length > 0
            ? decodeVIN.ProductionID
              ? decodeVIN.ProductionID
              : "--"
            : "--",
        "Trim Level":
          Object.keys(decodeVIN).length > 0
            ? decodeVIN.Trim
              ? decodeVIN.Trim
              : "--"
            : "--",
        "Fuel Type":
          Object.keys(decodeVIN.CatalogVehicleDescription).length > 0
            ? decodeVIN.CatalogVehicleDescription.Fuel
              ? decodeVIN.CatalogVehicleDescription.Fuel
              : "--"
            : "--",
        "Engine Code":
          Object.keys(decodeVIN.AdditionalAttributes).length > 0
            ? decodeVIN.AdditionalAttributes["Engine Code"]
            : "--",
        "Drive Line Type":
          Object.keys(decodeVIN).length > 0
            ? decodeVIN.DriveLineType
              ? decodeVIN.DriveLineType
              : "--"
            : "--",
        Country:
          Object.keys(decodeVIN).length > 0
            ? decodeVIN.CountryOfOrigin
              ? decodeVIN.CountryOfOrigin
              : "--"
            : "--",
      };
      //=== checking vin Items has itemResponse object and also checking itemResponse has items of filters
      if (
        vin.vinItems.hasOwnProperty("items") &&
        Object.keys(vin.vinItems.items).length > 0
      ) {
        if (
          vin.vinItems.hasOwnProperty("items") &&
          vin.vinItems.items.length > 0
        ) {
          loadVinData.filters = vin.vinItems.items;
        } else {
          loadVinData.filters = [];
        }
      }
      //===
    }
    setVinData(loadVinData);
  }, [vin]);

  // method to add vehicle from vin popup
  const onAdd = () => {
    dispatch(addItemInSelectedVehicle({}));
    const decodeVIN = vin.vinItems.decodedVIN;
    const addPayload = {
      vin:
        Object.keys(decodeVIN).length > 0
          ? decodeVIN.VIN
            ? decodeVIN.VIN
            : ""
          : "",
      make:
        Object.keys(decodeVIN).length > 0
          ? decodeVIN.Make
            ? decodeVIN.Make
            : ""
          : "",
      model:
        Object.keys(decodeVIN).length > 0
          ? decodeVIN.Model
            ? decodeVIN.Model
            : ""
          : "",
      makeModel: "",
      engine:
        Object.keys(decodeVIN.CatalogVehicleDescription).length > 0
          ? decodeVIN.CatalogVehicleDescription.hasOwnProperty("Engine")
            ? decodeVIN.CatalogVehicleDescription.Engine
            : ""
          : "",
      subModel: "",
      unitNo: "",
      sortBy: "",
      year:
        Object.keys(decodeVIN.CatalogVehicleDescription).length > 0
          ? decodeVIN.CatalogVehicleDescription.NAPAYearID
            ? decodeVIN.CatalogVehicleDescription.NAPAYearID
            : ""
          : "",
      comments: "",
    };
    props.onAdd(addPayload);
  };

  const getVinData = (key, val) => {
    return (
      <ListItem key={key} sx={LIST_STYLE} divider={true}>
        <Grid item xs={12} md={6} lg={6} sm={12}>
          <ListItemText primary={key} />
        </Grid>
        <Grid item xs={12} md={6} lg={6} sm={12}>
          <ListItemText primary={val} />
        </Grid>
      </ListItem>
    );
  };

  return (
    <React.Fragment>
      {vin.hasOwnProperty("vinItems") &&
      vin.vinItems.hasOwnProperty("error") &&
      Object.keys(vin.vinItems).length > 0 &&
      !vin.vinItems.hasOwnProperty("decodedVIN") ? (
        <Typo text={vin.vinItems.error.message} />
      ) : (
        vin.hasOwnProperty("vinItems") &&
        Object.keys(vin.vinItems).length > 0 && (
          <React.Fragment>
            <Grid container>
              <Grid item xs={12} md={12} lg={12} sm={12}>
                <List dense={false} sx={VIN_DECODER_VIEW}>
                  {localVinData.hasOwnProperty("vinData") &&
                    Object.entries(localVinData.vinData).map(([key, val]) =>
                      getVinData(key, val)
                    )}
                </List>
              </Grid>
            </Grid>
            <Grid container alignItems={"center"} sx={FILTER_SECTION_STYLE}>
              <Typo text={VIN_FILTER_TEXT} style={MARGIN_B} />
              <SelectView
                data={[
                  {
                    id: 0,
                    name: vin?.vinItems?.decodedVIN?.CatalogVehicleDescription?.hasOwnProperty(
                      "Engine"
                    )
                      ? vin?.vinItems?.decodedVIN?.CatalogVehicleDescription
                          ?.Engine
                      : "",
                  },
                ]}
                label={"Engine"}
                value={0}
              />
            </Grid>
            <Grid container>
              <Grid item xs={12} md={12} lg={12} sm={12}>
                <List
                  dense={false}
                  sx={{ ...VIN_DECODER_VIEW, ...VIN_DECODE_FILTER_VIEW }}
                >
                  {localVinData.hasOwnProperty("filters") &&
                  localVinData.filters.length > 0 ? (
                    localVinData.filters.map((data, i) => {
                      return (
                        <ListItem key={i} sx={LIST_STYLE} divider={true}>
                          <Grid item xs={12} md={5.9} lg={5.9} sm={12}>
                            <ListItemText primary={data.title} />
                          </Grid>
                          <Grid item xs={12} md={0.3} lg={0.3} sm={12}></Grid>
                          <Grid item xs={12} md={5.8} lg={5.8} sm={12}>
                            <ListItemText primary={data.partNumber} />
                          </Grid>
                        </ListItem>
                      );
                    })
                  ) : (
                    <Typo text={NO_DATA} style={CENTER_ITEMS} />
                  )}
                </List>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={12} lg={12} xs={12} sm={6} sx={PADDING_SM}>
                <ButtonGroup variant="outlined" style={RIGHT_ALIGN}>
                  <div style={{ ...RIGHT_ALIGN, ...MARGIN_TB }}>
                    <ButtonView
                      label={"Add"}
                      testid={"addNew"}
                      onClick={() => onAdd()}
                      disabled={selectedSurvey?.id ? false : true}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <ButtonView
                      label={"Exit"}
                      onClick={() => props.handleClose()}
                      testid={"Exit"}
                    />
                  </div>
                </ButtonGroup>
              </Grid>
            </Grid>
            {!selectedSurvey?.id &&  <Typo text={VIN_ID_MSG} style={HELPER_TEXT_STYLE} />}
          </React.Fragment>
        )
      )}
      {vin.hasOwnProperty("vinItems") &&
        Object.keys(vin.vinItems).length === 0 && <Typo text={NO_DATA} />}
      {Object.keys(vin).length !== 0 && vin.hasOwnProperty("message") && (
        <Typo text={LOADING_FAILED} />
      )}

      {Object.keys(vin).length === 0 && <Typo text={LOADING} />}
    </React.Fragment>
  );
};

export default VinDialogView;
